import {
    CENTRA_LOCALE_SHIPPING_COUNTRY_CODES,
    CentraLocaleShippingCountryCode
} from "@/data/centra-locale-shipping-country-code"
import { CENTRA_PRICELIST_CODE, CentraPricelistCode } from "@/data/supported-pricelists"

export type PricelistIdToPricelistCodeMap = Map<
    CentraLocaleShippingCountryCode,
    CentraPricelistCode
>

const shippingCountryCodeToPriceList: PricelistIdToPricelistCodeMap = new Map<
    CentraLocaleShippingCountryCode,
    CentraPricelistCode
>([
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.au, CENTRA_PRICELIST_CODE.aud],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.ca, CENTRA_PRICELIST_CODE.cad],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.ch, CENTRA_PRICELIST_CODE.chf],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.cz, CENTRA_PRICELIST_CODE.czk],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.dk, CENTRA_PRICELIST_CODE.dkk],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.gb, CENTRA_PRICELIST_CODE.gbp],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.jp, CENTRA_PRICELIST_CODE.jpy],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.no, CENTRA_PRICELIST_CODE.nok],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.nz, CENTRA_PRICELIST_CODE.nzd],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.pl, CENTRA_PRICELIST_CODE.pln],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.se, CENTRA_PRICELIST_CODE.sek],
    [CENTRA_LOCALE_SHIPPING_COUNTRY_CODES.us, CENTRA_PRICELIST_CODE.usd]
])

export default shippingCountryCodeToPriceList
